<template>
  <div class="single-product" @click="$bvModal.show(modalId)">
    <div class="count-area">
      <a href="#" @click.stop="handleMinus($event)">
        <span class="icon-icon_less"></span>
      </a>
      <div class="quantity" :title="program.count">{{ currentQuantity }}</div>
      <a @click.stop="handlePlus($event)">
        <span class="icon-icon_add"></span>
      </a>
    </div>

    <div class="single-product__name">
      {{ program.name }}
    </div>

    <div class="single-product__price">$ {{ programPrice }}</div>
    <ProgramModal
      :id="id"
      :program="program"
      :programIndex="index"
      :level="level"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import cloneDeepWith from 'lodash/cloneDeepWith';
import ProgramModal from '@/components/Modal/ProgramModal';

export default {
  components: {
    ProgramModal
  },
  props: {
    program: {
      type: Object,
      required: true
    },
    index: {
      required: true,
      type: Number
    },
    level: {
      type: Object,
      default() {
        return {
          name: '一般',
          discount_percentage: 1
        };
      }
    }
  },
  watch: {
    'program.count': function(newValue) {
      this.currentQuantity = newValue;
    }
  },
  computed: {
    programParams() {
      let temp = cloneDeepWith(this.program);

      return Object.assign(temp, {
        count: this.currentQuantity
      });
    },
    id() {
      return `program_${this.index}`;
    },
    modalId() {
      return `program-modal-${this.id}`;
    },
    programPrice() {
      return this.currentQuantity * this.program.price;
    }
  },
  data() {
    return {
      currentQuantity: 1
    };
  },
  created() {
    this.currentQuantity = this.program.count;
  },
  methods: {
    ...mapActions('order', ['removeProgram', 'updateProgram']),
    handlePlus() {
      alert('「此處無法增加方案數量，請直接選擇方案」');
      // e.preventDefault();
      // this.currentQuantity = this.currentQuantity + 1;
      // this.updateCartItem();
    },
    handleMinus(e) {
      e.preventDefault();
      let count = this.currentQuantity - 1;

      if (count == 0) {
        this.removeProgram(this.index);
      } else {
        this.currentQuantity = count;

        this.updateCartItem();
      }
    },
    updateCartItem() {
      this.updateProgram({
        program: this.programParams,
        programIndex: this.index
      });
    }
  }
};
</script>
